/* import __COLOCATED_TEMPLATE__ from './content-event-editor.hbs'; */
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
/* RESPONSIBLE TEAM: team-frontend-tech */
import { timeout } from 'ember-concurrency';
import { task } from 'ember-concurrency-decorators';
import { inject as service } from '@ember/service';
import ENV from 'embercom/config/environment';
import latinize from 'latinize';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { objectTypes } from 'embercom/models/data/matching-system/matching-constants';
let ContentEventEditor = (_dec = task({
  drop: true
}), _dec2 = task({
  drop: true
}), (_class = class ContentEventEditor extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "appService", _descriptor, this);
    _initializerDefineProperty(this, "store", _descriptor2, this);
    _initializerDefineProperty(this, "seriesEditorService", _descriptor3, this);
    _initializerDefineProperty(this, "contentObjectService", _descriptor4, this);
    _initializerDefineProperty(this, "contentObjects", _descriptor5, this);
    _initializerDefineProperty(this, "displayedContentObjects", _descriptor6, this);
    this.fetchContentEvents.perform();
  }
  get app() {
    return this.appService.app;
  }
  get contentTypeConfig() {
    return this.app.content_events_config[this.args.predicate.contentType];
  }
  get activeSeries() {
    return this.seriesEditorService.series;
  }
  get objectTypes() {
    return objectTypes;
  }
  get showOnlyLiveContent() {
    return this.args.showOnlyLiveContent;
  }
  *fetchContentEvents() {
    try {
      let contentObjects = yield this._getContentObjects();
      this.contentObjects = contentObjects.toArray();
      this.displayedContentObjects = contentObjects.toArray();

      // There's no generic default value for the content event predicate
      // So, if the predicate value is not set and we have at least one content object,
      // we set the predicate value to the first content object in the list
      if (!this.args.predicate.value && this.contentObjects.length > 0) {
        let value = this.contentObjects[0].content_object_id;
        this.args.changePredicateValue(value);
      }
    } catch (e) {
      this.contentObjects = [];
      this.displayedContentObjects = [];
    }
  }
  *filterContentObjects() {
    yield timeout(ENV.APP._200MS);
    this.displayedContentObjects = this.filteredItems(this.searchString);
  }
  filteredItems(filterText) {
    let items = this.contentObjects;
    if (items === undefined) {
      return [];
    }
    let downcasedFilterText = filterText.toLowerCase();
    return items.filter(item => {
      let text = latinize(item.displayedTitle);
      return typeof text !== 'string' || text.toLowerCase().includes(downcasedFilterText);
    });
  }
  async _getContentObjects() {
    let objectType = this.contentTypeConfig.content_type_number;
    let query = {
      object_type: objectType,
      show_only_live_content: this.showOnlyLiveContent
    };
    if (this.activeSeries && objectType !== objectTypes.series) {
      query.series_id = this.activeSeries.id;
      let seriesNodeIds = this.activeSeries?.nodes.mapBy('id');
      if (seriesNodeIds) {
        query.included_pending_node_ids = seriesNodeIds;
      }
    }
    let contentObjects;
    if (this.showOnlyLiveContent) {
      // used in checklists - it will receive a query for articles or tours
      contentObjects = await this.contentObjectService.objectSearch.perform(query);
    } else {
      contentObjects = await this.store.query('content-object', query);
    }
    if (this.args.predicate.basedOnGoal) {
      contentObjects = contentObjects.filter(contentObject => {
        return contentObject.has_goal;
      });
    }
    return contentObjects;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "appService", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "seriesEditorService", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "contentObjectService", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "contentObjects", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "displayedContentObjects", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "fetchContentEvents", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "fetchContentEvents"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "filterContentObjects", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "filterContentObjects"), _class.prototype)), _class));
export { ContentEventEditor as default };